<script>
import createChartComponent from "./createChartComponent";

export default createChartComponent("doughnut-chart", "doughnut");
</script>
